import React from 'react';
import Kyc from './Kyc';

// Profile Setup will contain specific tabs: Account Info, Logo & Banner, Company Info, WhatsApp Numbers, Email IDs, Categories
const profileTabs = ['accountInfo', 'media', 'categories', 'info', 'whatsapp', 'email'];

const ProfileSetup = () => {
  return <Kyc filterTabs={profileTabs} />;
};

export default ProfileSetup;
